import React from 'react'
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import moment from 'moment'
import { PageHeader, ListGroup, ListGroupItem, Button, Alert } from 'react-bootstrap'
import styled from 'styled-components'
import LanderPanel from './LanderPanel'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Bowser from 'bowser'

const browser = Bowser.getParser(window.navigator.userAgent)

const Panel = styled.div`
> h4 {
  font-family: "Open Sans", sans-serif;
  font-weight: 600;
  overflow: hidden;
  line-height: 1.5;
  white-space: nowrap;
  text-overflow: ellipsis;
  > p {
    color: #666;
  }
 }
`
const StyledListGroupItem = styled(ListGroupItem)`
 padding-bottom: 20px;
`
const StyledButton = styled(Button)`
  margin-left: 5px;
`

function FilesPanel({ isAuthenticated, isLoading, groupedFiles, openFile, downloadFile, errorOpeningFile }) {
  const sendingDates = Object.keys(groupedFiles)
  const type = {
    NF_: 'Nota Fiscal',
    NFSe_: 'Nota Fiscal',
    RPS_: 'RPS',
    BOLETO_: 'Boleto'
  }

  return (isAuthenticated
    ? <Panel>
        {errorOpeningFile && <Alert bsStyle="warning">
          É preciso habilitar o uso de pop-ups em seu navegador para abrir o documento solicitado.
          <Link to="/popup-block"> Clique aqui para mais detalhes</Link>.
        </Alert>}
        <PageHeader>Seus Arquivos</PageHeader>
        {isLoading && 'Carregando...'}
        {(!isLoading && !sendingDates.length) && <div>Caso não esteja visualizando seus arquivos, favor atualizar a página.</div>}
        {!isLoading && sendingDates.map(sendingDate =>
          <div key={sendingDate}>
            Enviado(s) em {moment(sendingDate).format('DD/MM/YYYY [às] HH:mm:ss')}:
            <ListGroup>
              {groupedFiles[sendingDate].files.map(file =>
                <StyledListGroupItem key={file.fileId} href="#">
                  <FontAwesomeIcon icon={file.type === 'BOLETO_' ? 'barcode' : 'file-invoice-dollar'} />&nbsp;
                  {type[file.type] || file.type}&nbsp;({getDisplayName(file)})
                  <StyledButton className="pull-right" bsStyle="info" onClick={downloadFile.bind(this, file)}>Baixar</StyledButton>
                  { /* New Window not allowed for IE users because of compatibility issues */
                    browser.getBrowserName() !== "Internet Explorer" &&
                    <Button className="pull-right" bsStyle="success" onClick={openFile.bind(this, file)}>Abrir em outra tela</Button>
                  }
                </StyledListGroupItem>
              )}
            </ListGroup>
          </div>
        )}
      </Panel>
    : <LanderPanel />)
}

function getDisplayName(file) {
  if (file.displayName) {
    return file.displayName
  }
  return file.name && file.name.indexOf('NFSe_') === 0 ? file.name.replace('NFSe_', '') : file.name
}

FilesPanel.propTypes = {
  isAuthenticated: PropTypes.bool,
  isLoading: PropTypes.bool,
  groupedFiles: PropTypes.object
}

export default FilesPanel
